import { render, staticRenderFns } from "./TakeExamPage.vue?vue&type=template&id=65b2ae0e&scoped=true"
import script from "./TakeExamPage.vue?vue&type=script&lang=js"
export * from "./TakeExamPage.vue?vue&type=script&lang=js"
import style0 from "./TakeExamPage.vue?vue&type=style&index=0&id=65b2ae0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b2ae0e",
  null
  
)

export default component.exports